"use client";

import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";
import { LeadRequestModal } from "@/components/landing/lead-request-modal";

type OpenArgs = {
  formCaseKey: string;
  title?: string;
  subtitle?: string;
};

type LeadRequestContextValue = {
  openLeadRequest: (args: OpenArgs) => void;
};

const LeadRequestContext = createContext<LeadRequestContextValue | null>(null);

export function LeadRequestProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [formCaseKey, setFormCaseKey] = useState("enterprise-request");
  const [title, setTitle] = useState<string | undefined>();
  const [subtitle, setSubtitle] = useState<string | undefined>();

  const openLeadRequest = useCallback((args: OpenArgs) => {
    setFormCaseKey(args.formCaseKey);
    setTitle(args.title);
    setSubtitle(args.subtitle);
    setOpen(true);
  }, []);

  const value = useMemo(() => ({ openLeadRequest }), [openLeadRequest]);

  return (
    <LeadRequestContext.Provider value={value}>
      {children}
      <LeadRequestModal
        open={open}
        formCaseKey={formCaseKey}
        title={title}
        subtitle={subtitle}
        onClose={() => setOpen(false)}
      />
    </LeadRequestContext.Provider>
  );
}

export function useLeadRequest(): LeadRequestContextValue {
  const ctx = useContext(LeadRequestContext);
  if (!ctx) {
    return {
      openLeadRequest: () => {
        console.warn("LeadRequestProvider отсутствует");
      },
    };
  }
  return ctx;
}
